// PSI <-> Bar Calculator tool: unit metadata + client-side field validation, used for
// instant inline feedback as the user types. The actual conversion math and the
// authoritative (server-side) validation live in the main backend — see
// src/lib/toolsApi.js (pressureToolApi) and backend/tools/pressure_tool.py.

export const DEFAULT_INPUTS = {
  unit: 'psi',
  value: 30,
};

// kPa is the canonical/base unit — every other unit's factor below is "1 <unit> = X kPa".
// Order here drives the order results are displayed in.
export const UNITS = [
  { value: 'kpa', label: 'kPa', name: 'Kilopascals' },
  { value: 'bar', label: 'bar', name: 'Bar' },
  { value: 'psi', label: 'psi', name: 'Pounds per Square Inch' },
  { value: 'atm', label: 'atm', name: 'Standard Atmosphere' },
];

// Pressure is a non-negative magnitude in this tool's automotive context (tire, hydraulic,
// boost gauge readings) — negative/vacuum gauge readings are not supported, unlike the
// Nm ↔ lb-ft Calculator's signed value. Mirrors FIELD_SPECS in
// backend/core/lookup/pressure_specs.py exactly.
export const FIELD_SPECS = [
  { key: 'value', label: 'Value', unit: '', group: 'input', min: 0, max: 1000000, strictlyPositive: false },
];

export const PRECISION_OPTIONS = [2, 3, 4, 5, 6];
export const DEFAULT_PRECISION = 4;

export function validateField(spec, rawValue) {
  if (rawValue === '' || rawValue === null || rawValue === undefined) {
    return 'Required.';
  }
  const value = Number(rawValue);
  if (Number.isNaN(value)) {
    return 'Must be a number.';
  }
  if (spec.strictlyPositive && value <= 0) {
    return 'Must be greater than 0.';
  }
  if (spec.min !== null && value < spec.min) {
    return value < 0 ? 'Pressure cannot be negative.' : `Must be ≥ ${spec.min}.`;
  }
  if (spec.max !== null && value > spec.max) {
    return `Must be ≤ ${spec.max}.`;
  }
  return null;
}
